//import FetchAPI from '../features/userprofile/api/FetchAPI'
import LandingSearch from './LandingSearch';
import Grid from '@mui/material/Grid';
import image from '../../resources/images/fleetBackgroundImage.jpg';
import React, { useState, useEffect } from "react";


const BackgroundImage = () => {

  const bgImageStyle = {
    backgroundImage: `linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.88) 39.56%, rgba(255, 255, 255, 0.8) 58%, rgba(255, 255, 255, 0) 83.49%),url(${image})`,
    backgroundSize: '90%',
    backgroundRepeat: 'repeat-x',
    backgroundPositionX: 'center',
    backgroundPositionY: '70%',
    height: '100%',
    width: '100%',
    overflow: 'auto',
    //backgroundAttachment: 'fixed',
  };

  return (
    <div
      className="bg-image"
      style={bgImageStyle}>
       <LandingSearch/> 
    </div>
  );
};

export default BackgroundImage;
